import Axios from 'axios'

Axios.defaults.baseURL = process.env.VUE_APP_URL;

/**
 * 首页内容API
 * @param {*} params API参数
 */
export const getNewsTop = params => {
    return Axios.get('/api/v1/article/getHatArticleTop5', {
        params: params
    });
}

export const getCarouselImgs = params => {
    return Axios.get('/api/v1/article/getCoverTop3', {
        params: params
    });
}

export const getArticleCategory = params => {
    return Axios.get('/api/v1/article/getCategorys', {
        params: params
    });
}

export const getNewsLetter = params => {
    return Axios.get('/api/v1/article/getFlashArticle', {
        params: params
    });
}

export const getHatTags = params => {
    return Axios.get('/api/v1/article/getHatTags', {
        params: params
    });
}

export const getPostList = params => {
    return Axios.get('/api/v1/post/list', {
        params: params
    });
}

export const getPostListHat = params => {
    return Axios.get('/api/v1/post/list/hat', {
        params: params
    });
}

export const getSetSwitch = params => {
    return Axios.get('/api/v1/article/switch', {
        params: params
    });
}

export const getBookList = params => {
    return Axios.get('/api/v1/book', {
        params: params
    });
}
/**end */

/**
 * 页面底部API
 * @param {*} params API参数
 */
export const getRelationLink = params => {
    return Axios.get('/api/v1/home/relationLink', {
        params: params
    });
}
/**end */

/**
 * 顶部菜单API
 * @param {*} params 
 */
export const getHomeMenu = params => {
    return Axios.get('/api/v1/article/getHomeMenu', {
        params: params
    });
}
/**end */

/**
 * 试卷API
 * @param {} params 
 */
export const getPaperTest = (params, headers) => {
    return Axios.get('/api/v1/paper/test', {
        params: params,
        headers: headers
    });
}

export const getExitPaperTest = (params, headers) => {
    return Axios.get('/api/v1/paper/exist/test', {
        params: params,
        headers: headers
    });
}

export const getHistoryPaperTest = (params, headers) => {
    return Axios.get('/api/v1/paper/history/test', {
        params: params,
        headers: headers
    });
}

export const getHistoryPaperList = (params, headers) => {
    return Axios.get('/api/v1/paper/history/list', {
        params: params,
        headers: headers
    });
}

export const sendPaperCalscore = (params, headers) => {
    return Axios({
        method: 'post',
        url: '/api/v1/paper/calscore',
        data: params,
        headers: headers
    });
}
/**end */

/**
 * 文章API
 * @param {*} params 
 * @param {*} headers 
 */
export const getArticleInfo = (params) => {
    return Axios.get('/api/v1/article/getArticleInfo', {
        params: params
    });
}

export const getAuthorArticles = (params) => {
    return Axios.get('/api/v1/article/getAuthorArticles', {
        params: params
    });
}

export const getArticleComments = (params) => {
    return Axios.get('/api/v1/comments/' + params.articleId);
}

export const getRecommonderArticles = (params) => {
    return Axios.get('/api/v1/article/recommonderArticles', {
        params: params
    });
}
/**end */

/**
 * 帖子API
 * @param {} params 
 */
export const getPostContent = (params) => {
    return Axios.get('/api/v1/post/main/post/' + params.articleId);
}

export const getPostComments = (params) => {
    return Axios.get('/api/v1/mainpost/comments/' + params.articleId);
}

/**end */